// extracted by mini-css-extract-plugin
module.exports = {"item":"SliderItem_item__GT6CV","slide":"SliderItem_slide__LcZN2","slider":"SliderItem_slider__WV0le"};